import { Navigate } from "react-router-dom";

function AuthContext({ children }) {
    return localStorage.getItem('admin') ? children : <Navigate to="/auth"/>
};

export default AuthContext;